import { gql } from '@apollo/client';

export default gql`
  query GetSystemActionTemplate($provider_id: Int!, $action_type: String!, $advisor_id: Int!) {
    getSystemActionTemplate(provider_id: $provider_id, action_type: $action_type, advisor_id: $advisor_id) {
      subject
      mail_from
      body_template
      source
    }
  }
`;
